// The same square crop is used in the editor and in the public hover avatar.
export function getTeacherAvatarStyle(image, crop) {
    if (!crop || crop.sourceImage !== image)
        return undefined;
    const side = Math.min(crop.imageWidth, crop.imageHeight) / crop.zoom;
    const width = (crop.imageWidth / side) * 100;
    const height = (crop.imageHeight / side) * 100;
    return {
        width: `${width}%`,
        height: `${height}%`,
        left: `${-((crop.x + 100) / 200) * (width - 100)}%`,
        top: `${-((crop.y + 100) / 200) * (height - 100)}%`,
    };
}
//# sourceMappingURL=teacher-images.js.map